import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card } from '@/components/ui/card'

/** Section shell shared by every settlement card. */
export function SectionCard({
  title,
  icon: Icon,
  action,
  children
}: {
  title: string
  icon: LucideIcon
  action?: ReactNode
  children: ReactNode
}) {
  return (
    <Card className="p-5 sm:p-6">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <h2 className="m-0 flex items-center gap-2.5 font-display text-xl font-bold tracking-tight text-ink">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Icon className="h-5 w-5" />
          </span>
          {title}
        </h2>
        {action}
      </div>
      {children}
    </Card>
  )
}

/**
 * Same content, lighter chrome. A wizard step is already inside a card, so
 * its sections must not stack another one.
 */
export function MaybeCard({
  embedded,
  title,
  icon,
  action,
  children
}: {
  embedded: boolean
  title: string
  icon: LucideIcon
  action?: ReactNode
  children: ReactNode
}) {
  if (!embedded) {
    return (
      <SectionCard title={title} icon={icon} action={action}>
        {children}
      </SectionCard>
    )
  }

  return (
    <div className="rounded-2xl border border-ink/[0.08] p-4">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h3 className="m-0 font-display text-base font-bold text-ink">
          {title}
        </h3>
        {action}
      </div>
      {children}
    </div>
  )
}
